import { useEffect, useReducer, useState } from 'react'
import classNames from 'classnames'
import { HIRAGANA_SETS, KATAKANA_SETS, ALL_HIRAGANA } from './kana'
import { getAllKanaFromSets, romajiPracticeReducer, getTimeSpan } from './utils'
import { ButtonUI, CardUI, AnswerButtonUI } from './App.styles'

export default function RomajiPractice({ sets, setPage, mode, timed }) {
  const availableKana = getAllKanaFromSets(sets)
  const [showTimer, setShowTimer] = useState(false)
  const [pauseTimer, setPauseTimer] = useState(false)
  const [currentTimer, setCurrentTimer] = useState(timed)
  const [state, dispatch] = useReducer(romajiPracticeReducer, {
    cardSide: 'question',
    streak: 0,
    missed: 0,
    inputValue: '',
    history: [],
    currentKana: undefined,
    answered: 'no',
  })

  useEffect(() => {
    dispatch({
      type: 'CHOOSE_FIRST_KANA',
      payload: { availableKana },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    let intervalId = null

    if (showTimer) {
      intervalId = setInterval(() => {
        if (state.finishedRun || pauseTimer) {
          clearInterval(intervalId)
        } else if (currentTimer > 0) {
          setCurrentTimer(currentTimer - 1000)
        } else {
          clearInterval(intervalId)
          dispatch({ type: 'FLIP' })
          setTimeout(() => {
            setCurrentTimer(timed)
            dispatch({
              type: 'ENTER_CORRECT',
              payload: { availableKana, mode },
            })
          }, 1000)
        }
      }, 1000)
    }
    return () => {
      clearInterval(intervalId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTimer, currentTimer, state.finishedRun, pauseTimer])

  function renderCardContent() {
    if (state.currentKana == null) return null
    if (state.cardSide === 'question') {
      return state.currentKana[1]
    }
    return state.currentKana[0]
  }

  return (
    <>
      <h1>
        Rōmaji to{' '}
        <span className="is-hiragana">
          {!!sets.find((set) => Object.keys(HIRAGANA_SETS).includes(set)) &&
            'Hiragana'}{' '}
        </span>
        <span className="is-katakana">
          {!!sets.find((set) => Object.keys(KATAKANA_SETS).includes(set)) &&
            'Katakana'}
        </span>
      </h1>

      {timed !== 0 && !showTimer && (
        <ButtonUI
          className="timer-control"
          onClick={() => {
            setShowTimer(true)
          }}
        >
          Start!
        </ButtonUI>
      )}

      {showTimer && !state.finishedRun && (
        <ButtonUI
          className="timer-control"
          onClick={() => {
            setPauseTimer(!pauseTimer)
          }}
        >
          {pauseTimer ? 'Resume' : 'Pause'}
        </ButtonUI>
      )}

      {!state.finishedRun ? (
        <CardUI
          className={classNames(
            'CardUI',
            `answered-${state.answered}`,
            state.currentKana && ALL_HIRAGANA.includes(state.currentKana[0])
              ? 'is-hiragana'
              : 'is-katakana'
          )}
          onClick={() => {
            dispatch({ type: 'FLIP' })
          }}
        >
          {renderCardContent()}
        </CardUI>
      ) : (
        <div>
          <div className="notice">
            <div>Finished all of them, well done!</div>
            <br />
            <div>
              Took you: {getTimeSpan(state.startTime, state.endTime).minutes}{' '}
              minutes {getTimeSpan(state.startTime, state.endTime).seconds}{' '}
              seconds
            </div>
            <ButtonUI
              onClick={() => {
                dispatch({
                  type: 'CHOOSE_FIRST_KANA',
                  payload: { availableKana },
                })
              }}
            >
              Restart
            </ButtonUI>
          </div>
        </div>
      )}
      {timed === 0 && !state.finishedRun && (
        <div>
          <AnswerButtonUI
            className="right"
            onClick={() => {
              dispatch({
                type: 'ENTER_CORRECT',
                payload: { availableKana, mode },
              })
            }}
          >
            Got it
          </AnswerButtonUI>
          <AnswerButtonUI
            className="wrong"
            onClick={() => {
              dispatch({
                type: 'NEXT_KANA',
                payload: { availableKana, mode },
              })
            }}
          >
            Nope
          </AnswerButtonUI>
        </div>
      )}
      <div className="info-box">
        {timed === 0 ? (
          <div className="info">
            Current streak: <strong>{state.streak}</strong>
          </div>
        ) : (
          <div className="info">
            Timer: <strong>{currentTimer / 1000}s</strong>
          </div>
        )}
        <div className="info">
          Studying <strong>{availableKana.length}</strong> Kanas
        </div>
        {timed === 0 && (
          <div className="info">
            Missed: <strong>{state.missed}</strong>
          </div>
        )}
        <div className="info">
          {timed === 0 ? 'Answered' : 'Count'}:{' '}
          <strong>{state.history.length}</strong>
        </div>
        <div className="info">
          Mode: {mode === 'oneGo' ? 'One go' : mode} {timed !== 0 && '(timed)'}
        </div>
      </div>
      <ButtonUI
        className="go-back"
        onClick={() => {
          setPage('config')
        }}
      >
        Go back to options
      </ButtonUI>
    </>
  )
}
